/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { useComponentTheme } from '../hooks/UNSAFE_useComponentTheme';
import { Separator } from '../UNSAFE_Separator';
import { MenuSeparatorRedwoodTheme } from './themes/redwood/MenuSeparatorTheme';

export function MenuSeparator() {
  const { classes } = useComponentTheme(MenuSeparatorRedwoodTheme);

  return (
    <div class={classes}>
      <Separator />
    </div>
  );
}
